import { createTheme } from "@mui/material/styles";

export const darkMode = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#63a528",
      contrastText: "#fff",
    },
    secondary: {
      main: "#63a526",
      contrastText: "#fff",
    },
    divider: "#63a526",
    background: {
      default: "#121212",
      paper: "#030303",
    },
  },
  props: {
    MuiTooltip: {
      arrow: true,
    },
  },
  typography: {
    fontFamily: "Fira Sans",
    h1: {
      fontFamily: "Big Shoulders Text",
      fontWeight: 500,
    },
    h2: {
      fontFamily: "Big Shoulders Text",
      fontWeight: 500,
    },
    h3: {
      fontFamily: "Big Shoulders Text",
      fontWeight: 500,
    },
    h4: {
      fontFamily: "Big Shoulders Text",
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h5: {
      fontFamily: "Big Shoulders Text",
      fontWeight: 600,
      lineHeight: 1.25,
    },
    h6: {
      fontFamily: "Big Shoulders Text",
      fontWeight: 600,
      lineHeight: 1.25,
    },
  },
  components: {
    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true,
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        fontFamily: "Big Shoulders Text",
        fontWeight: 600,
      },
    },
    MuiAppBar: {
      styleOverrides: {
        bgcolor: "primary.main",
      },
    },
  },
});
